






































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import ListMixin from "@/components/mixin/list-mixin";

import { mixins } from "vue-class-component";
import ViewCaseLabelSerials from "@/views/components/view-caselabel-serials.vue";
class viewProductLocationInfo {
  productName: string = "";
  productLocationId: number = 0;
  productId: number = 0;
  qty: number = 0;
}
class PageLocationRequest extends PageRequest {
  keyword: string = "";
}

@Component({
  components: { "view-serials": ViewCaseLabelSerials },
})
export default class Location extends mixins(
  ListMixin,
  DateTimeMixin,
  AbpBase
) {
  namespace = "location";

  get store() {
    return this.$store.state.location;
  }
  spinShow: boolean = false;
  //filters
  pagerequest: PageLocationRequest = new PageLocationRequest();
  viewModalShow: boolean = false;
  keyword: string = "";
  isShowInfo: boolean = false;
  viewProductLocation: viewProductLocationInfo = new viewProductLocationInfo();
  get loading() {
    return this.store.loading;
  }

  get locationInfo() {
    return this.$store.state.location.item;
  }

  get item() {
    if (this.locationInfo.items == null) return [];
    var re = this.locationInfo.items;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    return re;
  }
  viewDetails(index: number) {
    var productLocation = this.locationInfo.items[index];
    this.viewProductLocation.productLocationId =
      productLocation.productLocationId;
    this.viewProductLocation.productId = productLocation.productId;
    this.viewProductLocation.productName = productLocation.productName;
    this.viewProductLocation.qty = productLocation.qty;
    this.viewModalShow = true;
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "location/exportViewLocation",
      data: {
        keyword: this.pagerequest.keyword,
        warehouseCode: this.$store.state.session.tenant.tenancyName,
      },
    });
  }

  handleTransportHaveSosCancel() {
    this.$Modal.confirm({
      title:this.L('Confirm'),
      content:"Xác nhận xử lý thiết bị có SO hủy",
      okText:this.L('Yes'),
      cancelText:this.L('No'),
      onOk:()=>{
        this.spinShow = true;
        this.$store.dispatch({
          type: "transport/updateStatusTransportToPutAway",
          data: {
            id: this.locationInfo.locationId
          },
        }).then(() => {
          this.spinShow = false;
          Util.showSuccessMsg(this, "Xử lý thiết bị có SO hủy thành công.");
          this.getpage();
        }).catch(() => {
          this.spinShow = false;
        });
      }
    })
  }

  columns = [
    {
      title: Util.L("Order"),
      key: "orderNo",
      width: 50,
    },
    {
      title: Util.L("SKU"),
      key: "sku",
      width: 200,
    },
    {
      title: Util.L("ProductName"),
      key: "productName",
      width: 200,
    },
    {
      title: Util.L("Client"),
      key: "clientName",
      width: 100,
    },
    {
      title: Util.L("UnitName"),
      key: "unitName",
      width: 100,
    },
    {
      title: Util.L("StorageType"),
      key: "storageTypeName",
      width: 120,
    },
    {
      title: Util.L("AssetType"),
      width: 120,
      key: "assetTypeName",
    },
    {
      title: Util.L("ConditionType"),
      key: "conditionTypeName",
      width: 120,
    },
    {
      title: Util.L("Qty"),
      key: "qty",
      align: "right",
      width: 100,
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.qty));
      },
    },
    {
      title: Util.L("AllocatedQty"),
      key: "allocatedQty",
      align: "right",
      width: 100,
      render: (h: any, params: any) => {
        return h("span", Util.toViewNumberString(params.row.allocatedQty));
      },
    },
    {
      title: Util.L("UnconfirmedLostQty"),
      key: "unconfirmedLostQty",
      align: "right",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          Util.toViewNumberString(params.row.unconfirmedLostQty)
        );
      },
    },
    {
      title: this.L("Action"),
      slot: "action",
      width: 100,
      align: "center",
    },
  ];

  async getpage() {
    this.spinShow = true;
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store
      .dispatch({
        type: "location/getLocation",
        data: this.pagerequest,
      })
      .then(() => {
        this.isShowInfo = true;
        this.spinShow = false;
      })
      .catch(() => {
        this.spinShow = false;
      });
  }

  getPathThumbnailUrl(name: string) {
    return Util.getAppUrlImage(name);
  }

  created() {
    this.isShowInfo = false;
  }
}
